import * as moment from 'moment-timezone'

const methods = {
  moment: (date) => {
    return moment(date).tz('UTC')
  },
}
export default methods.moment
